<template>
  <div class="bnpl-topbar">
    <div class="topbar-actions">
      <button
        class="action-btn"
        title="Atualizar"
        @click="$emit('get-buy-now-pay-later')"
      >
        <b-icon icon="sync-alt" size="is-small" />
      </button>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.bnpl-topbar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1rem;
}

.topbar-actions {
  display: flex;
  gap: 0.35rem;
}

.action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #fff;
  color: #555;
  cursor: pointer;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
  outline: none;
}

.action-btn:hover {
  background: #fff4ee;
  border-color: #ff7034;
  color: #ff7034;
}
</style>
